import { render, staticRenderFns } from "./MessageView.vue?vue&type=template&id=02908c1c&scoped=true&"
import script from "./MessageView.vue?vue&type=script&lang=ts&"
export * from "./MessageView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02908c1c",
  null
  
)

export default component.exports